import { useState } from 'react'
import { Bell } from 'lucide-react'
import { useUnreadNotificationCount, useNotifications } from '@/lib/hooks'
import { NotificationList } from './notification-list'
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '@/components/ui/sheet'

export function NotificationBell() {
  const [open, setOpen] = useState(false)
  const { data: unreadCount = 0 } = useUnreadNotificationCount()
  useNotifications() // prefetch: Sheet を開いた瞬間に即表示するため

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="relative flex items-center justify-center rounded-full p-1.5 text-muted-foreground transition-colors hover:text-foreground"
      >
        <Bell className="size-5" />
        {unreadCount > 0 && (
          <span className="absolute top-0.5 right-0.5 size-2 rounded-full bg-destructive" />
        )}
      </button>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="top" className="max-h-[70dvh] rounded-b-2xl p-0" showCloseButton={false}>
          <SheetHeader className="border-b px-4 py-3">
            <SheetTitle>通知</SheetTitle>
            <SheetDescription className="sr-only">通知一覧</SheetDescription>
          </SheetHeader>
          <NotificationList onClose={() => setOpen(false)} />
        </SheetContent>
      </Sheet>
    </>
  )
}
